import { logPointsLandingOrigin, logPointsOrigin } from '../LogPointsPage/model'
import { selectVersion } from '../../../common/version/actions'
import { getResourceId } from '../../../common/resource/model'
import { logPointsOptions, setStateFromLandingAction } from '../LogPointsPage/actions'
import { Dispatch, GetState } from '../../../types'
import { goToLogPoints } from '../../Sidebar/Urls'
import {
  fetchMainSelectorsOptionsAndSelect,
  selectEnvironmentAndFetchAllResources,
  selectResourceAndFetchVersions
} from '../../../common/selector/actions'
import logPointsSelectors from '../LogPointsPage/selectors'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'

const commonOptions = {origin: logPointsLandingOrigin, lsOrigin: logPointsOrigin}

// Thunks

export const loadLogPointsLanding = () => (dispatch: Dispatch, getState: GetState) => {
  const logPointsState = getState().monitoring.logPoints

  const environmentSelector = logPointsState.environmentSelector
  const resourceSelector = logPointsState.resourceSelector
  const versionSelector = logPointsState.versionSelector

  const environment = environmentSelector.selected
  const resource = resourceSelector.selected
  const version = versionSelector.selected

  if (environment && resource) {
    goToLogPoints(environment.id, resource, version ? version.id.toString() : undefined)
  } else {
    dispatch(fetchMainSelectorsOptionsAndSelect(logPointsOptions(dispatch, commonOptions), undefined, undefined, undefined))
  }
}

export const environmentSelected = (environmentId: string) => (dispatch: Dispatch, getState: GetState) => {
  const environmentSelector = logPointsSelectors.landingPage.environmentSelector.getAll(getState())

  dispatch(selectEnvironmentAndFetchAllResources(logPointsOptions(dispatch, commonOptions), environmentId, environmentSelector.resources))
}

export const resourceSelected = (resourceId: string, resourceType: ResourceType) => (dispatch: Dispatch, getState: GetState) => {
  const resourceSelector = logPointsSelectors.landingPage.resourceSelector.getAll(getState())
  const opts = {...commonOptions, resourceType}

  dispatch(selectResourceAndFetchVersions(logPointsOptions(dispatch, opts), resourceId, resourceSelector.resources))
}

export const versionSelected = (versionId: string) => (dispatch: Dispatch, getState: GetState) => {
  const versionSelector = logPointsSelectors.landingPage.versionSelector.getAll(getState())

  dispatch(selectVersion(logPointsOptions(dispatch, commonOptions), versionSelector.resources || [], versionId))
}

export const viewLogPoints = (environmentId: string, resourceId: string, versionId?: string) => (dispatch: Dispatch, getState: GetState) => {
  const landingPageState = logPointsSelectors.landingPage
  const environmentSelector = landingPageState.environmentSelector.getAll(getState())
  const resourceSelector = landingPageState.resourceSelector.getAll(getState())
  const versionSelector = landingPageState.versionSelector.getAll(getState())
  const resource = resourceSelector.selected

  if (resource && getResourceId(resource) === resourceId) {
    dispatch(setStateFromLandingAction(environmentSelector, resourceSelector, versionSelector))

    goToLogPoints(environmentId, resource, versionId)
  }
}
